export default __webpack_public_path__ + "static/media/snapchat_i.e163be80.svg";